import { BASE_API_URL } from './index';

export const baseTaxEndpoint = (partnershipId) => `${BASE_API_URL}/partnerships/${partnershipId}/taxes`;
export const saveTaxInfoEndpoint = (partnershipId) => `${baseTaxEndpoint(partnershipId)}/confirm/`;
